import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CaqRequestService {

  constructor(
    private http: HttpClient,
    private toastrService: ToastrService
  ) { }

  handleError(error: HttpErrorResponse, toastrService: ToastrService) {
    if (error.status === 0) {
      toastrService.error('Não foi possível concluir a requisição', 'Error');
    }

    return of([] as any);
  }

  get<ReturnType>(url: string): Observable<ReturnType> {
    return this.http.get<ReturnType>(url)
      .pipe(catchError((err, _caught) => this.handleError(err, this.toastrService)))
  }

  post<ReturnType>(url: string, body: any): Observable<ReturnType> {
    return this.http.post<ReturnType>(url, body)
      .pipe(catchError((err, _caught) => this.handleError(err, this.toastrService)))
  }

  put<ReturnType>(url: string, body: any): Observable<ReturnType> {
    return this.http.put<ReturnType>(url, body)
      .pipe(catchError((err, _caught) => this.handleError(err, this.toastrService)))
  }

  postBlob(url: string, body: any): Observable<Blob> {
    return this.http.post(url, body, { responseType: 'blob' })
      .pipe(catchError((err, _caught) => {
        this.handleError(err, this.toastrService);
        return of(new Blob());
      }))
  }
}
